import {
  CancelableQueryViewArgs,
  query,
  Query,
  QueryHandlerFunction,
  QueryHandlerFunctionArgs,
} from "@lookiero/messaging";

const VIEW_IS_SALES_OFFFERING_ENABLED = "view_is_sales_offfering_enabled";

interface ViewIsSalesOfferingEnabled extends Query<typeof VIEW_IS_SALES_OFFFERING_ENABLED> {}

interface ViewIsSalesOfferingEnabledFunction {
  (): ViewIsSalesOfferingEnabled;
}

const viewIsSalesOfferingEnabled: ViewIsSalesOfferingEnabledFunction = () =>
  query({ name: VIEW_IS_SALES_OFFFERING_ENABLED });

type ViewIsSalesOfferingEnabledResult = boolean;

interface IsSalesOfferingEnabledViewArgs extends CancelableQueryViewArgs {}

interface IsSalesOfferingEnabledView {
  (args: IsSalesOfferingEnabledViewArgs): Promise<ViewIsSalesOfferingEnabledResult>;
}

interface ViewIsSalesOfferingEnabledHandlerFunctionArgs extends QueryHandlerFunctionArgs {
  readonly view: IsSalesOfferingEnabledView;
}

const viewIsSalesOfferingEnabledHandler: QueryHandlerFunction<
  ViewIsSalesOfferingEnabled,
  ViewIsSalesOfferingEnabledResult,
  ViewIsSalesOfferingEnabledHandlerFunctionArgs
> =
  ({ view, signal }) =>
  async () =>
    view({ signal });

export type { IsSalesOfferingEnabledView, ViewIsSalesOfferingEnabledResult };
export { VIEW_IS_SALES_OFFFERING_ENABLED, viewIsSalesOfferingEnabled, viewIsSalesOfferingEnabledHandler };
